import { Box, BoxProps } from "@mui/material";
import { background, black } from "@/theme/colors";
import { FC } from "react";
import { rounded } from "@/theme/variables";

export const CardContainer: FC<BoxProps> = ({ children, ...props }) => {
  return (
    <Box
      {...props}
      sx={{
        p: 3,
        bgcolor: background.white,
        borderRadius: rounded.sm,
        border: `1px solid ${black[99]}`,
        ...props.sx,
      }}
    >
      {children}
    </Box>
  );
};
